/* SET-PDP: Bundle-Komponenten via Storefront API (native Shopify "Bundles"-App)
   -----------------------------------------------------------------------------
   Ersetzt die frühere Datenquelle "custom.bundle_items"-Metafeld: liest
   stattdessen die nativen Bundle-Komponenten (ProductVariant.components) der
   aktuellen Produktvariante per Storefront-API (GraphQL) aus und rendert damit
   client-seitig sowohl die Buy-Box "Im Set enthalten"
   (blocks/_buybox-set-contents.liquid, [data-bundle-set-box]) als auch das
   Akkordeon "Was steckt in deinem Set?" (sections/pdp-set-products.liquid,
   [data-bundle-set-products]).

   Voraussetzung: Set-/Bundle-Produkte müssen über die native Shopify
   "Bundles"-App angelegt sein (nicht nur manuell "... Set" benannt) — nur
   dann liefert ProductVariant.components echte Einträge. Getestet gegen
   den Live-Shop: von den bisherigen "Set"-Produkten hat aktuell nur ein
   Teil (z. B. "Pollen Support Set") echte Bundle-Komponenten; ältere
   Set-Produkte ohne Bundles-App-Komponenten zeigen die Box/das Akkordeon
   dann bewusst nicht an (siehe leerer-Zustand unten).

   Hinweis Metafeld-Sichtbarkeit (Storefront API): "naehrwerte" ist bereits
   sichtbar. "buybox_vorteile" (Bullets) und "inhaltsstoffe" liefern aktuell
   `null`, weil die jeweilige Metafeld-Definition noch keinen Storefront-API-
   Zugriff erlaubt. Dafür in Admin unter Einstellungen → Individuelle Daten →
   Produkte → [Metafeld] → Zugriff verwalten → "Storefront API" aktivieren,
   sonst bleiben Bullets/Inhaltsstoffe im Set-Akkordeon leer. */
(function () {
  if (window.__maniaBundleInit) return;
  window.__maniaBundleInit = true;

  var boxEl = document.querySelector('[data-bundle-set-box]');
  var productsEl = document.querySelector('[data-bundle-set-products]');
  if (!boxEl && !productsEl) return;

  var cfg = boxEl || productsEl;
  var shopDomain = cfg.dataset.shopDomain;
  var token = cfg.dataset.storefrontToken;
  var apiVersion = cfg.dataset.apiVersion || '2026-07';
  var variantId = cfg.dataset.variantId;
  var designMode = cfg.dataset.designMode === 'true';

  if (!shopDomain || !token || !variantId) return;

  /* ---------- Helpers ---------- */
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function formatMoney(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(n);
    } catch (e) {
      return n.toFixed(2).replace('.', ',') + ' ' + (currency || 'EUR');
    }
  }
  function parseListMetafield(mf) {
    if (!mf || !mf.value) return [];
    try {
      var v = JSON.parse(mf.value);
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }
  /* Rendert ein Shopify-Rich-Text-Metafeld (JSON-Schema: root/paragraph/
     heading/list/list-item/link/text) als HTML — das Storefront-API-
     Äquivalent zu Liquids "metafield_tag"-Filter, der das serverseitig
     automatisch übernimmt. */
  function renderRichText(mf) {
    if (!mf || !mf.value) return '';
    var root;
    try { root = JSON.parse(mf.value); } catch (e) { return ''; }
    function renderNodes(nodes) {
      return (nodes || []).map(renderNode).join('');
    }
    function renderNode(node) {
      if (!node) return '';
      switch (node.type) {
        case 'root':
          return renderNodes(node.children);
        case 'paragraph':
          return '<p>' + renderNodes(node.children) + '</p>';
        case 'heading':
          var lvl = node.level || 2;
          return '<h' + lvl + '>' + renderNodes(node.children) + '</h' + lvl + '>';
        case 'list':
          var tag = node.listType === 'ordered' ? 'ol' : 'ul';
          return '<' + tag + '>' + renderNodes(node.children) + '</' + tag + '>';
        case 'list-item':
          return '<li>' + renderNodes(node.children) + '</li>';
        case 'link':
          return '<a href="' + esc(node.url || '#') + '"' + (node.target ? ' target="' + esc(node.target) + '"' : '') + '>' + renderNodes(node.children) + '</a>';
        case 'text':
          var t = esc(node.value);
          if (node.bold) t = '<strong>' + t + '</strong>';
          if (node.italic) t = '<em>' + t + '</em>';
          return t;
        default:
          return renderNodes(node.children);
      }
    }
    return renderNode(root);
  }
  function showHint(container, msg) {
    if (!container || !designMode) return;
    var hint = container.parentElement && container.parentElement.querySelector('[data-bundle-hint]');
    if (hint) { hint.hidden = false; hint.textContent = msg; }
  }

  /* ---------- Storefront API ----------
     Hinweis: Die Storefront API hat KEIN eigenes Root-Feld "productVariant(id:)"
     (das gibt es nur in der Admin API) — daher hier über das generische
     "node(id:)"-Feld + Inline-Fragment auf ProductVariant gelöst. */
  var QUERY = 'query BundleComponents($id: ID!) {' +
      'node(id: $id) {' +
        '... on ProductVariant {' +
        'price { amount currencyCode }' +
        'components(first: 20) {' +
          'nodes {' +
            'quantity ' +
            'productVariant {' +
              'price { amount currencyCode } ' +
              'product {' +
                'title ' +
                'onlineStoreUrl ' +
                'featuredImage { url altText } ' +
                'beschreibung: metafield(namespace: "custom", key: "produktbeschreibung") { value type } ' +
                'vorteile: metafield(namespace: "custom", key: "buybox_vorteile") { value type } ' +
                'naehrwerte: metafield(namespace: "custom", key: "naehrwerte") { value type } ' +
                'inhaltsstoffe: metafield(namespace: "custom", key: "inhaltsstoffe") { value type }' +
              '}' +
            '}' +
          '}' +
        '}' +
      '}' +
    '}' +
  '}';

  function fetchBundle(id) {
    window.__maniaBundleCache = window.__maniaBundleCache || {};
    var gid = /^gid:\/\//.test(id) ? id : ('gid://shopify/ProductVariant/' + id);
    var cacheKey = shopDomain + '|' + gid;
    if (window.__maniaBundleCache[cacheKey]) return window.__maniaBundleCache[cacheKey];
    var promise = fetch('https://' + shopDomain + '/api/' + apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query: QUERY, variables: { id: gid } })
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
        }
        var variant = json.data && json.data.node;
        var nodes = (variant && variant.components && variant.components.nodes) || [];
        return { bundlePrice: variant ? variant.price : null, components: nodes };
      });
    window.__maniaBundleCache[cacheKey] = promise;
    return promise;
  }

  /* ---------- Render: Buy-Box "Im Set enthalten" ---------- */
  function renderBox(el, data) {
    var components = data.components;
    if (!components.length) { showHint(el, 'Keine Bundle-Komponenten gefunden (Produkt nicht über die Bundles-App angelegt, oder Variante hat keine Komponenten).'); return; }

    var currency = (data.bundlePrice && data.bundlePrice.currencyCode) || 'EUR';
    var itemsTotal = 0;
    var listEl = el.querySelector('[data-setlist]');
    listEl.innerHTML = components.map(function (c) {
      var p = c.productVariant.product;
      var unit = parseFloat(c.productVariant.price.amount) || 0;
      var qty = c.quantity || 1;
      var lineTotal = unit * qty;
      itemsTotal += lineTotal;
      var img = p.featuredImage
        ? '<img src="' + esc(p.featuredImage.url) + '" width="80" loading="lazy" alt="' + esc(p.featuredImage.altText || p.title) + '">'
        : '<svg viewBox="0 0 40 74" fill="none" aria-hidden="true"><rect x="13" y="2" width="14" height="12" rx="3" fill="' + esc(el.dataset.colorJarDark) + '"/><rect x="6" y="13" width="28" height="59" rx="7" fill="' + esc(el.dataset.colorJar) + '"/><rect x="6" y="34" width="28" height="26" rx="3" fill="' + esc(el.dataset.colorJarLabel) + '"/></svg>';
      var name = (qty > 1 ? (qty + '× ') : '') + esc(p.title);
      return '<li class="setitem">' +
          '<span class="setitem__ic">' + img + '</span>' +
          '<span class="setitem__n">' + name + '</span>' +
          '<span class="setitem__v">' + esc(el.dataset.individualPricePrefix) + ' ' + formatMoney(lineTotal, currency) + '</span>' +
        '</li>';
    }).join('');

    var bundlePrice = parseFloat(data.bundlePrice && data.bundlePrice.amount) || 0;
    var savings = itemsTotal - bundlePrice;
    el.querySelector('[data-total]').textContent = formatMoney(itemsTotal, currency);
    el.querySelector('[data-bundle-price]').textContent = formatMoney(bundlePrice, currency);
    var badge = el.querySelector('[data-savings-badge]');
    if (savings > 0.004) {
      badge.hidden = false;
      badge.textContent = esc(el.dataset.savingsPrefix) + ' ' + formatMoney(savings, currency);
    }
    el.hidden = false;
  }

  /* ---------- Render: Akkordeon "Was steckt in deinem Set?" ---------- */
  function renderProducts(el, data) {
    var components = data.components;
    if (!components.length) { showHint(el, 'Keine Bundle-Komponenten gefunden (Produkt nicht über die Bundles-App angelegt, oder Variante hat keine Komponenten).'); return; }

    var sectionId = el.dataset.sectionId || 'set';
    var modalsHost = document.querySelector('[data-bundle-set-modals][data-section-id="' + sectionId + '"]');
    var accHtml = '';
    var modalsHtml = '';

    components.forEach(function (c, i) {
      var p = c.productVariant.product;
      var modalId = sectionId + '-' + i;
      var desc = renderRichText(p.beschreibung).trim();
      var bullets = parseListMetafield(p.vorteile).slice(0, 3);
      var hasNaehrwerte = !!(p.naehrwerte && p.naehrwerte.value);
      var hasInhaltsstoffe = !!(p.inhaltsstoffe && p.inhaltsstoffe.value);
      var img = p.featuredImage
        ? '<img src="' + esc(p.featuredImage.url) + '" loading="lazy" alt="' + esc(p.featuredImage.altText || p.title) + '">'
        : '<svg class="ptp__jar" viewBox="0 0 160 220" xmlns="http://www.w3.org/2000/svg"><rect x="46" y="6" width="68" height="26" rx="8" fill="' + esc(el.dataset.colorPlaceholderLid) + '"/><rect x="40" y="28" width="80" height="182" rx="18" fill="' + esc(el.dataset.colorPlaceholderJar) + '"/><rect x="58" y="86" width="44" height="70" rx="10" fill="' + esc(el.dataset.colorPlaceholderLabel) + '"/></svg>';

      accHtml += '<div class="pacc-i' + (i === 0 ? ' is-open' : '') + '" data-item="' + i + '">' +
          '<button class="pacc-q" aria-expanded="' + (i === 0 ? 'true' : 'false') + '">' +
            '<span class="pacc-q__n">' + esc(p.title) + '</span>' +
            '<span class="pacc-ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>' +
          '</button>' +
          '<div class="pacc-a">' +
            '<div class="pacc-a__in">' +
              '<div class="ptp__media">' + img + '</div>' +
              '<div class="ptp__body">' +
                '<h3 class="ptp__name">' + esc(p.title) + '</h3>' +
                (desc ? '<div class="ptp__desc">' + desc + '</div>' : '') +
                (bullets.length ? '<ul class="ptp__bullets">' + bullets.map(function (b) {
                  return '<li class="ptp__li"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>' + esc(b) + '</li>';
                }).join('') + '</ul>' : '') +
                '<div class="ptp__actions">' +
                  ((hasNaehrwerte || hasInhaltsstoffe) ? '<button class="ptp__more" type="button" data-modal="' + modalId + '">' + esc(el.dataset.modalButtonLabel) +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 8v8M8 12h8"/><circle cx="12" cy="12" r="9"/></svg>' +
                  '</button>' : '') +
                  (p.onlineStoreUrl ? '<a class="ptp__link" href="' + esc(p.onlineStoreUrl) + '">' + esc(el.dataset.productLinkLabel) +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
                  '</a>' : '') +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';

      if (hasNaehrwerte || hasInhaltsstoffe) {
        modalsHtml += '<div class="pmodal" data-modal-panel="' + modalId + '" aria-hidden="true">' +
            '<div class="pmodal__backdrop" data-close></div>' +
            '<div class="pmodal__box" role="dialog" aria-modal="true" aria-label="' + esc(el.dataset.modalButtonLabel) + ' ' + esc(p.title) + '">' +
              '<button class="pmodal__x" type="button" data-close aria-label="' + esc(el.dataset.modalCloseLabel) + '"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
              '<h4 class="pmodal__h">' + esc(p.title) + '</h4>' +
              (hasNaehrwerte ? '<div class="pdp-mf-table">' + p.naehrwerte.value + '</div>' : '') +
              (hasInhaltsstoffe ? '<div class="pmodal__ing pdp-mf-table">' + p.inhaltsstoffe.value + '</div>' : '') +
              (p.onlineStoreUrl ? '<a class="pmodal__link" href="' + esc(p.onlineStoreUrl) + '">' + esc(el.dataset.modalLinkLabel) +
                '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
              '</a>' : '') +
            '</div>' +
          '</div>';
      }
    });

    el.innerHTML = accHtml;
    if (modalsHost) modalsHost.innerHTML = modalsHtml;
    el.hidden = false;

    initAccordion(el);
    initModals(el, modalsHost);
  }

  function initAccordion(el) {
    var items = [].slice.call(el.querySelectorAll('.pacc-i'));
    function setOpen(it, open) {
      var a = it.querySelector('.pacc-a'), btn = it.querySelector('.pacc-q');
      it.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      a.style.maxHeight = open ? (a.scrollHeight + 'px') : '0px';
    }
    items.forEach(function (it) {
      setOpen(it, it.classList.contains('is-open'));
      it.querySelector('.pacc-q').addEventListener('click', function () {
        var open = !it.classList.contains('is-open');
        items.forEach(function (o) { if (o !== it) setOpen(o, false); });
        setOpen(it, open);
      });
    });
    window.addEventListener('resize', function () {
      items.forEach(function (it) { if (it.classList.contains('is-open')) { var a = it.querySelector('.pacc-a'); a.style.maxHeight = a.scrollHeight + 'px'; } });
    });
  }

  function initModals(el, modalsHost) {
    if (!modalsHost) return;
    var modals = modalsHost.querySelectorAll('.pmodal');
    if (!modals.length) return;
    function open(id) {
      var m = modalsHost.querySelector('.pmodal[data-modal-panel="' + id + '"]');
      if (m) { m.classList.add('is-open'); m.setAttribute('aria-hidden', 'false'); document.body.classList.add('modal-open'); }
    }
    function closeAll() {
      modalsHost.querySelectorAll('.pmodal.is-open').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
      document.body.classList.remove('modal-open');
    }
    el.querySelectorAll('.ptp__more').forEach(function (b) { b.addEventListener('click', function () { open(b.dataset.modal); }); });
    modalsHost.querySelectorAll('[data-close]').forEach(function (x) { x.addEventListener('click', closeAll); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- Start ---------- */
  fetchBundle(variantId).then(function (data) {
    if (boxEl) renderBox(boxEl, data);
    if (productsEl) renderProducts(productsEl, data);
  }).catch(function (err) {
    console.error('[mania-pdp-bundle] Storefront-API-Fehler:', err);
    if (boxEl) showHint(boxEl, 'Storefront-API-Fehler: ' + err.message);
    if (productsEl) showHint(productsEl, 'Storefront-API-Fehler: ' + err.message);
  });
})();
